<template>
  <!-- 多种类型 -->
  <div class="id_4 clear">
    <div class="tabs_box">
      <!-- 轮播区域 -->
      <div class="tabs clear" :style="{'left': arrowIndex*(-116)+'px'}">
        <div class="tabs_item cursor fl"
        :class="{'back':indexs==index}"
        v-for="(o, index) in data.list"
        :key="o.tabs+index"
        @click="indexs=index">{{o.tabs}}</div>
      </div>
    </div>
    <!-- 左右箭头 -->
    <div class="arrow" v-if="data.list.length>6">
      <div class="left cursor el-icon-arrow-left" @click="arrow(1)" v-if="arrowIndex!=0"></div>
      <div class="right cursor el-icon-arrow-right" @click="arrow(2)" v-if="arrowIndex!=data.list.length-6"></div>
    </div>

    <div class="box" v-for="(i, index) in data.list" :key="i.title+index" v-show="indexs==index">
      <div class="title bold" v-html="i.title"></div>
      <div class="text" id="id_4_img" v-html="i.text"></div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  name: 'id_4',
  data () {
    return {
      arrowIndex: 0,
      indexs: 0
    }
  },
  methods: {
    // 轮播图  1左  2右
    arrow (type) {
      if (type === 1) {
        this.arrowIndex--
      } else if (type === 2) {
        this.arrowIndex++
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.id_4{
  padding-top: 32px;
  word-wrap:break-word;
  .tabs_box{
    width: 704px;
    height: 104px;
    overflow: hidden;
    position: relative;
  }
  .arrow{
    position: relative;
    .left,.right{
      position: absolute;
      font-size: 32px;
      background-color: rgba(0,0,0,0.3);
      line-height: 88px;
    }
    .left{
      top: -96px;
      left: -32px;
    }
    .right{
      top: -96px;
      right: -32px;
    }
  }
  .tabs{
    top: 0;
    left: 0;
    width: 10000px;
    position: absolute;
    transition: all 0.3s;
    .tabs_item{
      width: 104px;
      height: 104px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #EBEEF5;
      color: #303133;
      margin-right: 12px;
    }
    .back{
      background-color: #296BFF;
      color: #fff;
    }
  }
  .box{
    border: 1px solid #dcdfe6;
    padding: 24px;
    margin-top: 24px;
    border-radius: 4px;
    .title{
      font-size: 16px;
      line-height: 26px;
    }
    .text{
      margin-top: 24px;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>

<style lang="scss">
.id_4 #id_4_img img{
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_4.vue